export default {"src":"/_next/static/media/LVS.5c977d49.svg","height":18,"width":18};